<template>   
    <div class="warranty-container">     
        <!-- 查询前状态 -->
        <div class="search-header" v-if="!showResult && !showMsg">  
            <van-image
                width="300"
                :src="icon"
                class="header-icon"
            />
            <h4 class="header-title">如何找到序列号</h4>
            <p class="header-subtitle">请输入产品序列号查询保修信息</p>
        </div>

        <!-- 搜索区域 -->
        <div class="search-section">
            <van-field
                v-model="keyword"
                center
                clearable
                label="序列号"
                placeholder="请输入序列号"
                class="search-field"
            >
                <van-button 
                    slot="button" 
                    round 
                    class="search-btn"
                    @click="onSearch"
                >
                    查询
                </van-button>
            </van-field>
        </div>

        <!-- 查询结果 -->
        <div class="result-container" v-show="showResult">
            <div class="product-card">
                <van-image
                    width="140"
                    :src="printerImage"
                    class="product-image"
                />     
                
                <div class="product-info">
                    <h3 class="product-name">{{ printerName }}</h3>
                    <div class="info-item">
                        <span class="info-label">商品编码：</span>
                        <span class="info-value">{{ pn }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">序列号：</span>
                        <span class="info-value">{{ sn }}</span>
                    </div>
                </div>
            </div>

            <div class="warranty-info">
                <div class="info-section">
                    <h4 class="section-title">标准保修信息</h4>
                    <div class="info-item">
                        <van-icon name="calendar" class="info-icon" />
                        <span class="info-label">出厂日期：</span>
                        <span class="info-value">{{ scan_date }}</span>
                    </div>
                    <div class="info-item">
                        <van-icon name="shield" class="info-icon" />
                        <span class="info-label">保修结束：</span>
                        <span class="info-value">出厂日期起{{ inwMonths }}月</span>
                    </div>
                    <div class="warranty-note">
                        <van-icon name="info" class="note-icon" />
                        如用户提供购买凭证，则以购买凭证记载日期开始计算
                    </div>
                </div>

                <div class="info-section" v-if="svcCode">
                    <h4 class="section-title">延保信息</h4>
                    <!-- <div class="info-item">
                        <van-icon name="certificate" class="info-icon" />
                        <span class="info-label">延保产品：</span>
                        <span class="info-value">{{ svcCode }}</span>
                    </div> -->
                    <div class="info-item">
                        <van-icon name="description" class="info-icon" />
                        <span class="info-label">产品详情：</span>
                        <span class="info-value">{{ detail }}</span>
                    </div>
                    <div class="info-item">
                        <van-icon name="play-circle" class="info-icon" />
                        <span class="info-label">开始日期：</span>
                        <span class="info-value">{{ startDate }}</span>
                    </div>
                    <div class="info-item">
                        <van-icon name="stop-circle" class="info-icon" />
                        <span class="info-label">结束日期：</span>
                        <span class="info-value">{{ endDate }}</span>
                    </div>
                     <!-- <div class="info-item">
                        <van-icon name="stop-circle" class="info-icon" />
                        <span class="info-label">上门服务时间：</span>
                        <span class="info-value">{{ onsiteMonths }}</span>
                    </div>
                      <div class="info-item">
                        <van-icon name="stop-circle" class="info-icon" />
                        <span class="info-label">上门服务范围：</span>
                        <span class="info-value">{{ condition1 }}</span>
                    </div> -->
                      <div class="warranty-note">
                        <van-icon name="info" class="note-icon" />
                        服务产品信息以购买方与至像科技签订的购买凭证为准<br/>查询结果仅供参考，最终解释权归至像科技所有。
                    </div>
                </div>
            </div>
        </div>

        <!-- 无结果提示 -->
        <div class="empty-state" v-show="showMsg">
            <van-empty 
                description="没有找到出库信息" 
                image="search"
            >
                <van-button 
                    round 
                    type="primary" 
                    class="retry-btn"
                    @click="resetSearch"
                >
                    重新查询
                </van-button>
            </van-empty>
        </div>     
    </div>
</template>

<script>
  import Vue from 'vue'
  import global  from '../../components/global.vue';
  import { Toast } from 'vant'
  
  export default {
    name: 'shipinfo',	 
    data(){
        return{			
            keyword :'',
            icon:require('../../assets/help.png'),
            showResult : false,
            showMsg: false,
            printerImage:'',
            printerName:'',
            sn:'',
            pn:'',
            scan_date:'',
            oowdate:'',
            svcCode:'',
            detail:'',
            startDate:'',
            endDate:'',
            onsiteMonths:'',
            condition1:'',
            inwMonths: ''
        }  	 
    },
    mounted(){	
        document.title ='保修信息查询';
    },
    methods:{
        onSearch(){
            if (!this.keyword.trim()) {
                Toast('请输入序列号');
                return;
            }
            global.applog(this.keyword, '保修信息查询')
            this.getData()
        },
        getData(){
            let that = this 
            let actualimg = ''
            let defaultprinter = require('../../assets/icon/defaultprinter.png');
            // 重置显示状态
            that.showResult = false;
            that.showMsg = false;
            
            Vue.axios.get("https://abcapi.lenovoimage.com/v1/device/shipmentinfo?appid=abcios&sn="  + this.keyword)
            .then(function (response) {
                console.log('API响应:', response.data);
                if (response.data.code == "0" && response.data.data) {                  
                    var obj = response.data;
                    that.printerName = obj.data[0].erpname || '未知产品';
                    that.sn = that.keyword;
                    that.pn = obj.data[0].erpcode || '未知编码';
                    that.scan_date = obj.data[0].scan_date || "未知";
                    that.oowdate = obj.data[0].oowdate || "未知";
                    if (obj.data[0].printerimg)
                    {
                        actualimg = obj.data[0].printerimg;
                    }
                    else
                    {
                        actualimg = defaultprinter;
                    }
                    that.printerImage = actualimg;
                    
                    // 设置延保信息，确保数据存在
                    var obj2 = response.data.data2;
                      console.log('API响应2:', obj2);
                    if (obj2 && obj2.length > 0) {
                        that.svcCode = obj2[0].srvcode || "";
                        that.startDate = obj2[0].stardate || "";
                        that.endDate = obj2[0].enddate || "";
                        that.detail = obj2[0].svcName || "";
                        that.onsiteMonths = obj2[0].onsiteMonths || "";
                         that.condition1 = obj2[0].condition1 || "";
                         //获取保修月数
                         that.inwMonths =  obj2[0].imwMonths ;
                        
                    }              
                    // 显示结果
                    that.showResult = true;
                    that.showMsg = false;
                    
                } else {
                    // 没有找到数据
                    that.showResult = false;
                    that.showMsg = true;
                    Toast('未找到该序列号的保修信息');
                }
            })
            .catch(function (error) {
                console.log('API错误:', error);
                that.showResult = false;
                that.showMsg = true;
                Toast('查询失败，请检查网络连接');
            }) 					
        },
        resetSearch() {
            this.showResult = false;
            this.showMsg = false;
            this.keyword = '';
        }
    }
  }
</script>

<style scoped>
.warranty-container {
    background-color: #f7f8fa;
    min-height: 100vh;
    padding: 0 0 50px 0;
    
}

.search-header {
    text-align: center;
    padding: 60px 20px 40px;
}

.header-icon {
    margin-bottom: 20px;
}

.header-title {
    font-size: 18px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 8px;
}

.header-subtitle {
    font-size: 14px;
    color: #969799;
    margin: 0;
}

.search-section {
    background-color: #ffffff;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.search-field {
    padding: 0;
}

.search-btn {
    background-color: #1989fa;
    color: white;
    border: none;
    width: 70px;
    height: 32px;
}

.result-container {
    padding: 16px;
}

.product-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
}

.product-image {
    margin-bottom: 16px;
}

.product-name {
    font-size: 16px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 12px;
}

.product-info {
    text-align: left;
}

.info-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    font-size: 14px;
}

.info-label {
    color: #646566;
    min-width: 70px;
}

.info-value {
    color: #323233;
    font-weight: 500;
}

.warranty-info {
    background-color: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
}

.info-section {
    padding: 20px;
    border-bottom: 1px solid #f5f5f5;
}

.info-section:last-child {
    border-bottom: none;
}

.section-title {
    font-size: 15px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
}

.info-icon {
    font-size: 14px;
    color: #1989fa;
    margin-right: 8px;
    width: 16px;
}

.warranty-note {
    background-color: #fff7e6;
    border: 1px solid #ffd591;
    border-radius: 6px;
    padding: 12px;
    font-size: 12px;
    color: #d46b08;
    margin-top: 12px;
    display: flex;
    align-items: flex-start;
}

.note-icon {
    font-size: 14px;
    color: #fa8c16;
    margin-right: 8px;
    flex-shrink: 0;
    margin-top: 1px;
}

.empty-state {
    padding: 60px 20px;
}

.retry-btn {
    margin-top: 16px;
}
</style>